import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { first } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { FeedbackService } from 'src/app/core/helpers/feedback.service';
import { TranslateService } from '@ngx-translate/core';
import { GaService } from 'src/app/core/helpers/ga.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

declare var $: any;

@Component({
  selector: 'loyaltic-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  contactForm!: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string = '';
  modalRef!: BsModalRef;
  IsmodelShow = true;
   @ViewChild('closeBtn', { static: false }) closeBtnPopUpRef: any;
  @ViewChild('feedbackSuccess', { static: false }) feedbackSuccessRef: any;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private contactService: FeedbackService,
    @Inject('ImagePath') public ImagePath,
    public translate: TranslateService,
    private modalService: BsModalService,
    public gaService: GaService,
  ) { }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      // email: ['', [Validators.required, Validators.email]],
      email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      subject: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(1000)]],
      message: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(1000)]]
    });

    console.table(this.contactForm.errors);
  }

  get f() { return this.contactForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }

    this.loading = true;

    this.contactService.sendMessage(this.f.name.value, this.f.email.value, this.f.subject.value, this.f.message.value).pipe(first())
      .subscribe(data => {
        // this.gtmService.pushTag({ event: 'feed-back', status: 'Success' });
        this.gaService.emitEvent('feedback', 'feedback screen');
        this.loading = false;
        this.contactForm.reset();
        this.contactForm.clearValidators();
        this.IsmodelShow = false;
        this.closeBtnPopUpRef.nativeElement.click();
        this.router.navigate(['/']).then(() => {
          this.modalRef = this.modalService.show(this.feedbackSuccessRef, this.popupConfig);
        });
      },
        error => {
          this.loading = false;
          this.router.navigate(['/feedback/success'], { queryParams: { status: 'failure' } });
        });
  }

  closeSuccessModal() {
    this.modalRef.hide();
  }

}
